export class FolioScrapperRequest {
   tipo: number;
   emisorId: string;
   sucursalId: string;
   usuarioId: string;
}
